import { Container, Content } from './styles';

export const AuthLayout: React.FC = ({ children }) => (
  <Container>
    <Content>
      {children}
    </Content>
  </Container>
);
